export default __webpack_public_path__ + "static/tooltip-interactive-1-do-dark-6ea3e2a3f168038c69d12e5ba5cb1873.png";